import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["smartLinkActionType"],
  _excluded2 = ["smartLinkActionType"],
  _excluded3 = ["smartLinkActionType"],
  _excluded4 = ["display"];
var _SmartLinkActionTypeT, _SmartLinkActionTypeU;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getMeasure } from '../performance';
import { SmartLinkActionType } from '@atlaskit/linking-types';
export var ANALYTICS_CHANNEL = 'media';
export var context = {
  componentName: 'smart-cards',
  packageName: "@atlaskit/smart-card",
  packageVersion: "28.3.0"
};
export var TrackQuickActionType = /*#__PURE__*/function (TrackQuickActionType) {
  TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
  return TrackQuickActionType;
}({});
export var TrackQuickActionFailureReason = /*#__PURE__*/function (TrackQuickActionFailureReason) {
  TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
  TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
  TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
  return TrackQuickActionFailureReason;
}({});
export var SmartLinkActionTypeTrackingEventMapper = (_SmartLinkActionTypeT = {}, _defineProperty(_SmartLinkActionTypeT, SmartLinkActionType.FollowEntityAction, 'Follow'), _defineProperty(_SmartLinkActionTypeT, SmartLinkActionType.StatusUpdateAction, 'StatusUpdate'), _defineProperty(_SmartLinkActionTypeT, SmartLinkActionType.UnfollowEntityAction, 'Unfollow'), _SmartLinkActionTypeT);
export var SmartLinkActionTypeUiEventMapper = (_SmartLinkActionTypeU = {}, _defineProperty(_SmartLinkActionTypeU, SmartLinkActionType.FollowEntityAction, 'smartLinkFollowButton'), _defineProperty(_SmartLinkActionTypeU, SmartLinkActionType.UnfollowEntityAction, 'smartLinkFollowButton'), _SmartLinkActionTypeU);
var uiActionSubjectIds = {
  DownloadAction: 'downloadDocument',
  PreviewAction: 'invokePreviewScreen',
  ViewAction: 'shortcutGoToLink',
  StatusAction: 'issueStatusUpdate'
};
export var SmartLinkEvents = /*#__PURE__*/function () {
  function SmartLinkEvents() {
    _classCallCheck(this, SmartLinkEvents);
  }
  _createClass(SmartLinkEvents, [{
    key: "insertSmartLink",
    value: function insertSmartLink(url, type, createAnalyticsEvent) {
      fireSmartLinkEvent({
        action: 'inserted',
        actionSubject: 'smartLink',
        eventType: 'track',
        attributes: {
          type: type
        },
        nonPrivacySafeAttributes: {
          domainName: url
        }
      }, createAnalyticsEvent);
    }
  }]);
  return SmartLinkEvents;
}();
export var fireSmartLinkEvent = function fireSmartLinkEvent(payload, createAnalyticsEvent) {
  if (createAnalyticsEvent) {
    createAnalyticsEvent(payload).fire(ANALYTICS_CHANNEL);
  }
};
export var resolvedEvent = function resolvedEvent(props) {
  return {
    action: 'resolved',
    actionSubject: 'smartLink',
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread({}, props), context)
  };
};
export var unresolvedEvent = function unresolvedEvent(_ref) {
  var id = _ref.id,
    definitionId = _ref.definitionId,
    extensionKey = _ref.extensionKey,
    resourceType = _ref.resourceType,
    destinationSubproduct = _ref.destinationSubproduct,
    destinationProduct = _ref.destinationProduct,
    error = _ref.error,
    status = _ref.status,
    location = _ref.location;
  return {
    action: 'unresolved',
    actionSubject: 'smartLink',
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      id: id
    }, context), definitionId ? {
      definitionId: definitionId
    } : {}), extensionKey ? {
      extensionKey: extensionKey
    } : {}), resourceType ? {
      resourceType: resourceType
    } : {}), destinationSubproduct ? {
      destinationSubproduct: destinationSubproduct
    } : {}), destinationProduct ? {
      destinationProduct: destinationProduct
    } : {}), location ? {
      location: location
    } : {}), {}, {
      reason: status,
      error: error ? {
        message: error === null || error === void 0 ? void 0 : error.message,
        kind: error === null || error === void 0 ? void 0 : error.kind,
        type: error === null || error === void 0 ? void 0 : error.type
      } : undefined
    })
  };
};
export var invokeSucceededEvent = function invokeSucceededEvent(_ref2) {
  var id = _ref2.id,
    actionType = _ref2.actionType,
    display = _ref2.display,
    extensionKey = _ref2.extensionKey,
    definitionId = _ref2.definitionId,
    destinationProduct = _ref2.destinationProduct,
    destinationSubproduct = _ref2.destinationSubproduct,
    location = _ref2.location;
  var measure = id ? getMeasure(id, 'resolved') : undefined;
  return {
    action: 'resolved',
    actionSubject: 'smartLinkAction',
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      actionType: actionType,
      display: display,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      extensionKey: extensionKey,
      duration: measure === null || measure === void 0 ? void 0 : measure.duration
    })
  };
};
export var invokeFailedEvent = function invokeFailedEvent(_ref3) {
  var id = _ref3.id,
    actionType = _ref3.actionType,
    display = _ref3.display,
    reason = _ref3.reason,
    extensionKey = _ref3.extensionKey,
    definitionId = _ref3.definitionId,
    destinationProduct = _ref3.destinationProduct,
    destinationSubproduct = _ref3.destinationSubproduct,
    location = _ref3.location;
  var measure = id ? getMeasure(id, 'errored') : undefined;
  return {
    action: 'unresolved',
    actionSubject: 'smartLinkAction',
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      actionType: actionType,
      display: display,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      duration: measure === null || measure === void 0 ? void 0 : measure.duration,
      reason: reason
    })
  };
};
export var connectSucceededEvent = function connectSucceededEvent(_ref4) {
  var definitionId = _ref4.definitionId,
    extensionKey = _ref4.extensionKey,
    destinationProduct = _ref4.destinationProduct,
    destinationSubproduct = _ref4.destinationSubproduct,
    location = _ref4.location;
  return {
    action: 'connectSucceeded',
    actionSubject: 'smartLink',
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      definitionId: definitionId,
      extensionKey: extensionKey,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};
export var connectFailedEvent = function connectFailedEvent(_ref5) {
  var definitionId = _ref5.definitionId,
    extensionKey = _ref5.extensionKey,
    destinationProduct = _ref5.destinationProduct,
    destinationSubproduct = _ref5.destinationSubproduct,
    location = _ref5.location,
    reason = _ref5.reason;
  return {
    action: 'connectFailed',
    actionSubject: 'smartLink',
    actionSubjectId: reason,
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      reason: reason,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};
export var trackAppAccountConnected = function trackAppAccountConnected(_ref6) {
  var definitionId = _ref6.definitionId,
    extensionKey = _ref6.extensionKey,
    destinationProduct = _ref6.destinationProduct,
    destinationSubproduct = _ref6.destinationSubproduct,
    location = _ref6.location;
  return {
    action: 'connected',
    actionSubject: 'applicationAccount',
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      definitionId: definitionId,
      extensionKey: extensionKey,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};
export var trackAppAccountAuthStarted = function trackAppAccountAuthStarted(_ref7) {
  var extensionKey = _ref7.extensionKey,
    location = _ref7.location;
  return {
    action: 'authStarted',
    actionSubject: 'applicationAccount',
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      extensionKey: extensionKey,
      location: location
    })
  };
};
export var trackSmartLinkQuickActionStarted = function trackSmartLinkQuickActionStarted(_ref8) {
  var _SmartLinkActionTypeT2;
  var smartLinkActionType = _ref8.smartLinkActionType,
    attributes = _objectWithoutProperties(_ref8, _excluded);
  return {
    action: 'started',
    actionSubject: 'smartLinkQuickAction',
    eventType: 'track',
    attributes: _objectSpread(_objectSpread(_objectSpread({}, context), attributes), {}, {
      smartLinkActionType: (_SmartLinkActionTypeT2 = SmartLinkActionTypeTrackingEventMapper[smartLinkActionType]) !== null && _SmartLinkActionTypeT2 !== void 0 ? _SmartLinkActionTypeT2 : smartLinkActionType
    })
  };
};
export var trackSmartLinkQuickActionSuccess = function trackSmartLinkQuickActionSuccess(_ref9) {
  var _SmartLinkActionTypeT3;
  var smartLinkActionType = _ref9.smartLinkActionType,
    attributes = _objectWithoutProperties(_ref9, _excluded2);
  return {
    action: 'success',
    actionSubject: 'smartLinkQuickAction',
    eventType: 'track',
    attributes: _objectSpread(_objectSpread(_objectSpread({}, context), attributes), {}, {
      smartLinkActionType: (_SmartLinkActionTypeT3 = SmartLinkActionTypeTrackingEventMapper[smartLinkActionType]) !== null && _SmartLinkActionTypeT3 !== void 0 ? _SmartLinkActionTypeT3 : smartLinkActionType
    })
  };
};
export var trackSmartLinkQuickActionFailed = function trackSmartLinkQuickActionFailed(_ref10) {
  var _SmartLinkActionTypeT4;
  var smartLinkActionType = _ref10.smartLinkActionType,
    attributes = _objectWithoutProperties(_ref10, _excluded3);
  return {
    action: 'failed',
    actionSubject: 'smartLinkQuickAction',
    eventType: 'track',
    attributes: _objectSpread(_objectSpread(_objectSpread({}, context), attributes), {}, {
      smartLinkActionType: (_SmartLinkActionTypeT4 = SmartLinkActionTypeTrackingEventMapper[smartLinkActionType]) !== null && _SmartLinkActionTypeT4 !== void 0 ? _SmartLinkActionTypeT4 : smartLinkActionType
    })
  };
};
export var trackHoverCardResolutionStarted = function trackHoverCardResolutionStarted(_ref11) {
  var display = _ref11.display,
    attributes = _objectWithoutProperties(_ref11, _excluded4);
  return {
    action: 'resolved',
    actionSubject: 'hoverCard',
    eventType: 'track',
    attributes: _objectSpread(_objectSpread(_objectSpread({}, context), attributes), {}, {
      display: display
    })
  };
};
export var uiAuthEvent = function uiAuthEvent(_ref12) {
  var definitionId = _ref12.definitionId,
    extensionKey = _ref12.extensionKey,
    destinationProduct = _ref12.destinationProduct,
    destinationSubproduct = _ref12.destinationSubproduct,
    location = _ref12.location,
    display = _ref12.display;
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'connectAccount',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      definitionId: definitionId,
      extensionKey: extensionKey,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      display: display
    })
  };
};
export var uiAuthAlternateAccountEvent = function uiAuthAlternateAccountEvent(_ref13) {
  var definitionId = _ref13.definitionId,
    extensionKey = _ref13.extensionKey,
    destinationProduct = _ref13.destinationProduct,
    destinationSubproduct = _ref13.destinationSubproduct,
    location = _ref13.location,
    display = _ref13.display;
  return {
    action: 'clicked',
    actionSubject: 'smartLink',
    actionSubjectId: 'tryAnotherAccount',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      definitionId: definitionId,
      extensionKey: extensionKey,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      display: display
    })
  };
};
export var uiCardClickedEvent = function uiCardClickedEvent(_ref14) {
  var id = _ref14.id,
    display = _ref14.display,
    status = _ref14.status,
    definitionId = _ref14.definitionId,
    extensionKey = _ref14.extensionKey,
    isModifierKeyPressed = _ref14.isModifierKeyPressed,
    location = _ref14.location,
    destinationProduct = _ref14.destinationProduct,
    destinationSubproduct = _ref14.destinationSubproduct,
    actionSubjectId = _ref14.actionSubjectId;
  return {
    action: 'clicked',
    actionSubject: 'smartLink',
    actionSubjectId: actionSubjectId,
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      status: status,
      definitionId: definitionId,
      extensionKey: extensionKey,
      display: display,
      isModifierKeyPressed: isModifierKeyPressed,
      location: location,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct
    })
  };
};
export var uiIframeDwelledEvent = function uiIframeDwelledEvent(_ref15) {
  var id = _ref15.id,
    display = _ref15.display,
    status = _ref15.status,
    definitionId = _ref15.definitionId,
    extensionKey = _ref15.extensionKey,
    location = _ref15.location,
    destinationProduct = _ref15.destinationProduct,
    destinationSubproduct = _ref15.destinationSubproduct,
    dwellTime = _ref15.dwellTime,
    dwellPercentVisible = _ref15.dwellPercentVisible;
  return {
    action: 'dwelled',
    actionSubject: 'smartLinkIframe',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      status: status,
      definitionId: definitionId,
      extensionKey: extensionKey,
      display: display,
      location: location,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      dwellTime: dwellTime,
      dwellPercentVisible: dwellPercentVisible
    })
  };
};
export var uiIframeFocusedEvent = function uiIframeFocusedEvent(_ref16) {
  var id = _ref16.id,
    display = _ref16.display,
    status = _ref16.status,
    definitionId = _ref16.definitionId,
    extensionKey = _ref16.extensionKey,
    location = _ref16.location,
    destinationProduct = _ref16.destinationProduct,
    destinationSubproduct = _ref16.destinationSubproduct;
  return {
    action: 'focused',
    actionSubject: 'smartLinkIframe',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      status: status,
      definitionId: definitionId,
      extensionKey: extensionKey,
      display: display,
      location: location,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct
    })
  };
};
export var uiActionClickedEvent = function uiActionClickedEvent(_ref17) {
  var id = _ref17.id,
    actionType = _ref17.actionType,
    extensionKey = _ref17.extensionKey,
    display = _ref17.display,
    definitionId = _ref17.definitionId,
    destinationProduct = _ref17.destinationProduct,
    destinationSubproduct = _ref17.destinationSubproduct,
    location = _ref17.location;
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: uiActionSubjectIds[actionType],
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      display: display,
      actionType: actionType,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};
export var uiClosedAuthEvent = function uiClosedAuthEvent(_ref18) {
  var display = _ref18.display,
    extensionKey = _ref18.extensionKey,
    definitionId = _ref18.definitionId,
    destinationProduct = _ref18.destinationProduct,
    destinationSubproduct = _ref18.destinationSubproduct,
    location = _ref18.location;
  return {
    action: 'closed',
    actionSubject: 'consentModal',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      display: display
    })
  };
};
export var screenAuthPopupEvent = function screenAuthPopupEvent(_ref19) {
  var extensionKey = _ref19.extensionKey,
    definitionId = _ref19.definitionId,
    destinationProduct = _ref19.destinationProduct,
    destinationSubproduct = _ref19.destinationSubproduct,
    location = _ref19.location;
  return {
    actionSubject: 'consentModal',
    eventType: 'screen',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};
export var uiRenderSuccessEvent = function uiRenderSuccessEvent(_ref20) {
  var display = _ref20.display,
    status = _ref20.status,
    extensionKey = _ref20.extensionKey,
    definitionId = _ref20.definitionId,
    destinationProduct = _ref20.destinationProduct,
    destinationSubproduct = _ref20.destinationSubproduct,
    location = _ref20.location,
    canBeDatasource = _ref20.canBeDatasource;
  return {
    action: 'renderSuccess',
    actionSubject: 'smartLink',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      status: status,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      display: display,
      canBeDatasource: canBeDatasource
    })
  };
};
export var uiRenderFailedEvent = function uiRenderFailedEvent(_ref21) {
  var display = _ref21.display,
    error = _ref21.error,
    errorInfo = _ref21.errorInfo,
    extensionKey = _ref21.extensionKey,
    definitionId = _ref21.definitionId,
    destinationProduct = _ref21.destinationProduct,
    destinationSubproduct = _ref21.destinationSubproduct,
    location = _ref21.location;
  return {
    actionSubject: 'smartLink',
    action: 'renderFailed',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      error: error,
      errorInfo: errorInfo,
      display: display,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};
export var uiHoverCardViewedEvent = function uiHoverCardViewedEvent(_ref22) {
  var id = _ref22.id,
    previewDisplay = _ref22.previewDisplay,
    extensionKey = _ref22.extensionKey,
    definitionId = _ref22.definitionId,
    destinationProduct = _ref22.destinationProduct,
    destinationSubproduct = _ref22.destinationSubproduct,
    location = _ref22.location,
    previewInvokeMethod = _ref22.previewInvokeMethod,
    status = _ref22.status;
  return {
    action: 'viewed',
    actionSubject: 'hoverCard',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      previewDisplay: previewDisplay,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      previewInvokeMethod: previewInvokeMethod,
      status: status
    })
  };
};
export var uiHoverCardDismissedEvent = function uiHoverCardDismissedEvent(_ref23) {
  var id = _ref23.id,
    previewDisplay = _ref23.previewDisplay,
    hoverTime = _ref23.hoverTime,
    extensionKey = _ref23.extensionKey,
    definitionId = _ref23.definitionId,
    destinationProduct = _ref23.destinationProduct,
    destinationSubproduct = _ref23.destinationSubproduct,
    location = _ref23.location,
    previewInvokeMethod = _ref23.previewInvokeMethod,
    status = _ref23.status;
  return {
    action: 'dismissed',
    actionSubject: 'hoverCard',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      previewDisplay: previewDisplay,
      hoverTime: hoverTime,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      previewInvokeMethod: previewInvokeMethod,
      status: status
    })
  };
};
export var uiHoverCardOpenLinkClickedEvent = function uiHoverCardOpenLinkClickedEvent(_ref24) {
  var id = _ref24.id,
    previewDisplay = _ref24.previewDisplay,
    extensionKey = _ref24.extensionKey,
    definitionId = _ref24.definitionId,
    destinationProduct = _ref24.destinationProduct,
    destinationSubproduct = _ref24.destinationSubproduct,
    location = _ref24.location,
    previewInvokeMethod = _ref24.previewInvokeMethod;
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'shortcutGoToLink',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      previewDisplay: previewDisplay,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      previewInvokeMethod: previewInvokeMethod
    })
  };
};
export var uiLearnMoreLinkClickedEvent = function uiLearnMoreLinkClickedEvent() {
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'learnMore',
    eventType: 'ui',
    attributes: _objectSpread({}, context)
  };
};
export var chunkloadFailedEvent = function chunkloadFailedEvent(_ref25) {
  var display = _ref25.display,
    error = _ref25.error,
    errorInfo = _ref25.errorInfo,
    extensionKey = _ref25.extensionKey,
    definitionId = _ref25.definitionId,
    destinationProduct = _ref25.destinationProduct,
    destinationSubproduct = _ref25.destinationSubproduct,
    location = _ref25.location;
  return {
    action: 'chunkLoadFailed',
    actionSubject: 'smartLink',
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      error: error,
      errorInfo: errorInfo,
      display: display,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};
export var uiSmartLinkStatusLozengeButtonClicked = function uiSmartLinkStatusLozengeButtonClicked() {
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'smartLinkStatusLozenge',
    eventType: 'ui',
    attributes: _objectSpread({}, context)
  };
};
export var uiSmartLinkStatusListItemButtonClicked = function uiSmartLinkStatusListItemButtonClicked() {
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'smartLinkStatusListItem',
    eventType: 'ui',
    attributes: _objectSpread({}, context)
  };
};
export var uiSmartLinkStatusOpenPreviewButtonClicked = function uiSmartLinkStatusOpenPreviewButtonClicked() {
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'smartLinkStatusOpenPreview',
    eventType: 'ui',
    attributes: _objectSpread({}, context)
  };
};
export var uiServerActionClicked = function uiServerActionClicked(_ref26) {
  var _SmartLinkActionTypeU2;
  var smartLinkActionType = _ref26.smartLinkActionType;
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: (_SmartLinkActionTypeU2 = SmartLinkActionTypeUiEventMapper[smartLinkActionType]) !== null && _SmartLinkActionTypeU2 !== void 0 ? _SmartLinkActionTypeU2 : smartLinkActionType,
    eventType: 'ui',
    attributes: _objectSpread({}, context)
  };
};